import styled, { css } from "styled-components";
import { MenuElement } from "../common-style";
import { StyledStaffLines } from "../../../../components/Nav/StaffLines";
import { NavLink } from "react-router-dom";
import { ILanguageOptionStyleProps } from "./interfaces";

export const StyledNavRight = styled.div`
    transition: transform 400ms, opacity 400ms;
    justify-content: flex-end;
    display: flex;
    flex: 1;
    padding-right: 16px;
    opacity: 1;
`;

export const SmallIcon = styled.div`
    display: inline-block;

    svg {
        width: 28px;
        height: 28px;
        margin: -5px 3px -7px -3px;
    }
`;

export const MenuItem = styled(NavLink)`
    ${MenuElement}
`;


export const StyledLogin = styled.div`
    ${MenuElement}
`;

export const Moderation = styled(MenuItem)`
    ${p =>
        p.theme.sm.only(css`
            display: none;
        `)}
`;

export const Caret = styled.div`
    margin-left: 6px;
`;

export const StyledStaffLinesRight = styled.div`
    ${StyledStaffLines}
    position: absolute;
    right: auto;
    transition: opacity 400ms;
    ${p =>
        p.theme.lg(css`
            left: calc(${p => p.theme.$screenLg}px - 15px - 12px - 11px);
        `)}
    ${p =>
        p.theme.md.only(css`
            left: calc(${p => p.theme.$screenMd}px - 15px - 12px - 11px);
        `)}
    ${p =>
        p.theme.sm.only(css`
            left: calc(${p => p.theme.$screenSm}px - 15px - 12px - 11px);
        `)}
    ${p =>
        p.theme.xs(css`
            left: calc(100vw - ${12 + 11}px);
        `)}
    top: 0;
    pointer-events: none;

`;

export const StaffLinesRightStart = styled.svg`
    position: absolute;
    top: 0;
    left: 0;
    width: 23px !important;
    height: 100%;

    rect,
    circle {
        fill: ${p => p.theme.c.snow};
    }
`;

const $userDimension = 30;
export const UserImage = styled.div`
    border-radius: ${$userDimension / 2}px;
    overflow: hidden;
    width: ${$userDimension}px;
    height: ${$userDimension}px;
    margin-right: 12px;
    box-sizing: border-box;

    .i-user {
        font-size: ${$userDimension}px;
        color: ${p => p.theme.c.dark};
    }

    img {
        width: ${$userDimension}px;
        height: ${$userDimension}px;
    }
`;

export const Usermenu = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    right: -12px;
    background-color: ${p => p.theme.c.boost};
    width: 100%;
    min-width: 150px;
    text-align: left;
    padding: 10px 6px;
    box-sizing: border-box;
    box-shadow: 0 0 5px 0 ${p => p.theme.c.blackShadow3};
    overflow-y: auto;
    cursor: default;
    border-radius: 0 0 8px 8px;
`;

export const UserName = styled.div`
    display: inline-block;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const UserMenuItem = css`
    margin-bottom: 6px;
    height: 28px;
`;

export const Account = styled(MenuItem)`
    ${UserMenuItem}
    margin-top: 0;
`;

export const Logout = styled.div`
    ${MenuElement}
    ${UserMenuItem}
    margin-bottom: 0;
`;

export const MobileMenuOpener = styled.div`
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}

    margin-top: 2px;
    padding: 12px;
    display: flex;
    cursor: pointer;
    align-items: center;

    > div {
        height: 20px;
    }

    .Line {
        width: 21px;
        margin-top: 4px;
        height: 3px;
        background-color: ${p => p.theme.c.dark};
        transition: 0.3s;

        &.Line1 {
            margin-top: 0;
        }
    }

    .Active {
        .Line1 {
            transform: rotate(-45deg) translate(-4.7px, 5.2px) scale(1.24, 1);
        }

        .Line2 {
            transform: scale(0, 1);
        }

        .Line3 {
            transform: rotate(45deg) translate(-4.7px, -5.2px) scale(1.24, 1);
        }
    }
`;

export const ChangeLanguage = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    padding: 2px 6px;
    margin: 10px 2px;
    font-size: 18px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline: none;
    color: ${p => p.theme.c.snow};

    polygon {
        fill: ${p => p.theme.c.dark};
    }
`;

export const LanguageDropdown = styled(Usermenu)`
    top: calc(100% + 10px);
    min-width: 222px;
    ${p =>
        p.theme.xs(css`
            right: -59px;
            min-width: 260px;
        `)}
`;

export const LanguageOption = styled.div<ILanguageOptionStyleProps>`
    ${MenuElement}
    ${UserMenuItem}
    height: auto;
    line-height: 21px;
    ${p =>
        p.isActive &&
        css`
            color: white;
        `}
    display: block !important;
    ${p =>
        p.theme.xs(css`
            font-weight: 400;
            font-size: 17px;
            line-height: 24px;
        `)}
`;

// const NotificationCount = styled.div`
//     background-color: ${p => p.theme.c.wrong};
//     position: absolute;
//     bottom: 4px;
//     right: -2px;
//     width: 12px;
//     height: 12px;
//     border-radius: 8px;
//     color: ${p => p.theme.c.snow};
//     font-size: 10px;
//     line-height: 13px;
//     text-align: center;
//     font-family: arial, serif;
//     font-weight: 300;
// `;

export const User = styled.div`
    ${MenuElement}
    color: ${p => p.theme.c.snow};
    margin-right: 12px;

    &:hover {
        color: ${p => p.theme.c.snow};
        svg {
            fill: ${p => p.theme.c.dark};
        }

        .Caret {
            svg {
                fill: ${p => p.theme.c.pale};
            }
        }
    }
`;
